import { Node } from "#/decision_tree_viewer/models/node";

export class AllowBookingNode extends Node {
  get defaults() {
    return {
      id: "allow-booking",
      name: "AllowBookingNode",
    };
  }
}
